import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolder, faRss, faFilm } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import DocIcon from './DocIcon';
import {
  isDocFSObject,
  isStudioFSObject,
  getFSRefObject,
} from './fsObjectUtils';

const StyledFSIcon = styled.span`
  font-size: 24px;
`;

const FSObjectIcon = ({ item }) => {
  let node = <FolderIcon />;
  if (isDocFSObject(item)) {
    node = <DocIcon doc={getFSRefObject(item)} />;
  } else if (isStudioFSObject(item)) {
    node = <StudioIcon />;
  } 

  return <StyledFSIcon>{node}</StyledFSIcon>;
};

export const FolderIcon = () => (
  <FontAwesomeIcon icon={faFolder} color={'#000'} />
);

export const StudioIcon = () => (
  <>
    <FontAwesomeIcon icon={faRss} color={'red'} />
    <span className="visually-hidden">Studio document</span>
  </>
);

export const TheaterIcon = () => (
  <>
    <FontAwesomeIcon icon={faFilm} color={'#9065FF'} />
    <span className="visually-hidden">Theater</span>
  </>
);

FSObjectIcon.propTypes = {
  item: PropTypes.object,
};

export default FSObjectIcon;
